
import React from 'react';
import { Button } from '@/components/ui/button';
import { Upload } from 'lucide-react';

interface ImportStepProps {
  hasParsedData: boolean;
  hasErrors: boolean;
  isDisabled: boolean;
  isUploading: boolean;
  onImport: () => void;
}

const ImportStep: React.FC<ImportStepProps> = ({ 
  hasParsedData, 
  hasErrors, 
  isDisabled, 
  isUploading, 
  onImport 
}) => {
  return (
    <div className="mt-6">
      <h2 className="text-lg font-medium mb-2 text-hormony-charcoal">Step 3: Import Data</h2>
      <p className="text-muted-foreground mb-4">
        After validation, click Import to add your cycle data to your account.
      </p>
      
      <Button
        onClick={onImport}
        disabled={!hasParsedData || hasErrors || isDisabled || isUploading}
        className="bg-hormony-coral hover:bg-hormony-dark-coral text-white"
      >
        {isUploading ? (
          <>
            <div className="mr-2 h-4 w-4 animate-spin rounded-full border-2 border-current border-t-transparent"></div>
            Importing...
          </>
        ) : (
          <>
            <Upload className="mr-2 h-4 w-4" />
            Import Data
          </>
        )}
      </Button>
      
      {isUploading && (
        <p className="text-sm text-muted-foreground mt-2 animate-pulse">
          Please wait while we process your data...
        </p>
      )}
    </div>
  );
};

export default ImportStep;
